var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRIconMatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "R_Icon_Matches") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-\\u2013-Iconography",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R_Icon_Matches"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container",
    opacity: 0,
    fill: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Home",
    transform: "translate(1, 2)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3831252,7.61885077 C11.9883423,7.22261729 11.4527905,7 10.894352,7 C10.3359135,7 9.80036171,7.22261729 9.40557878,7.61885077 L8.99989764,8.02583141 L8.5942165,7.61885077 C7.77198975,6.79399024 6.43889681,6.79399025 5.61667006,7.61885079 C4.79444332,8.44371134 4.79444331,9.78107451 5.61667004,10.6059351 L6.02235118,11.0129157 L8.99989764,14 L11.9774441,11.0129157 L12.3831252,10.6059351 C12.7780935,10.2098875 13,9.67262021 13,9.11239292 C13,8.55216563 12.7780935,8.0148983 12.3831252,7.61885077 Z",
    id: "Heart"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 7 9 0 18 7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIconMatches);
export default __webpack_public_path__ + "static/media/R_Icon_Matches.f165fcfad1b0d795cd6fe4992d6db6f4.svg";
export { ForwardRef as ReactComponent };